import { addSpinner, removeSpinner } from './spinner.js';

export function showOverlay( sub, loading, content = null, hideSpinner = null ) {
  let overlay = null;
  //creat element if not in dom
  if( document.getElementsByClassName('overlay').length < 1 ){
    overlay = document.createElement('div');
    overlay.classList.add('overlay');
    document.body.appendChild(overlay);
  } else {
    overlay = document.getElementsByClassName( 'overlay' )[0];
  }
  //sub class
  if( sub ){
    overlay.classList.add('sub');
  }
  //add spinner
  if( loading ){
    addSpinner(overlay);
  }
  //if content
  if( content ){
    overlay.appendChild( content );
  }
  //if hide spinner
  if ( hideSpinner ){
    removeSpinner(overlay);
  }

  return overlay;
}

export function removeOverlay(){
  if( document.getElementsByClassName('overlay').length > 0 ){
    let overlay = document.getElementsByClassName( 'overlay' )[0];
    //if spinner, remove
    if( document.getElementsByClassName('lds-ring').length > 0){
      removeSpinner( overlay );
    }
    //remove overlay
    overlay.parentNode.removeChild(overlay);
  }
}
